import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const keywordsEn = [
  { label: 'Shower Doors Las Vegas', path: '/services' },
  { label: 'Frameless Shower Doors Las Vegas', path: '/services' },
  { label: 'Glass Railings Las Vegas', path: '/services' },
  { label: 'Custom Mirrors Las Vegas', path: '/services' },
  { label: 'Glass Company Las Vegas', path: '/services' },
  { label: 'Tub Enclosures Las Vegas', path: '/services' },
  { label: 'Sliding Shower Doors Las Vegas', path: '/services' },
  { label: 'Glass Installation Las Vegas', path: '/services' },
  { label: 'Shower Glass Henderson NV', path: '/service-areas' },
  { label: 'Glass Railings Summerlin', path: '/service-areas' },
  { label: 'Mirror Installation Las Vegas', path: '/services' },
  { label: 'Glass Stair Railing Las Vegas', path: '/services' },
  { label: 'Shower Door Replacement Las Vegas', path: '/services' },
  { label: 'Glass Partitions Las Vegas', path: '/services' },
  { label: 'Bathroom Glass Las Vegas', path: '/services' },
];

const keywordsEs = [
  { label: 'Puertas de Ducha Las Vegas', path: '/services' },
  { label: 'Puertas Sin Marco Las Vegas', path: '/services' },
  { label: 'Barandales de Vidrio Las Vegas', path: '/services' },
  { label: 'Espejos Personalizados Las Vegas', path: '/services' },
  { label: 'Empresa de Vidrio Las Vegas', path: '/services' },
  { label: 'Cerramientos de Bañera Las Vegas', path: '/services' },
  { label: 'Puertas Corredizas Las Vegas', path: '/services' },
  { label: 'Instalación de Vidrio Las Vegas', path: '/services' },
  { label: 'Vidrio Henderson NV', path: '/service-areas' },
  { label: 'Barandales Summerlin', path: '/service-areas' },
  { label: 'Instalación de Espejos Las Vegas', path: '/services' },
  { label: 'Barandal de Escalera Las Vegas', path: '/services' },
  { label: 'Reemplazo de Puerta de Ducha', path: '/services' },
  { label: 'Particiones de Vidrio Las Vegas', path: '/services' },
  { label: 'Vidrio de Baño Las Vegas', path: '/services' },
];

const KeywordsBar = () => {
  const { i18n } = useTranslation();
  const isEs = i18n.resolvedLanguage === 'es';
  const keywords = isEs ? keywordsEs : keywordsEn;

  return (
    <section className="py-12 bg-[#F8F8F6] border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <p className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-5 text-center">
          {isEs ? 'Nuestros Servicios de Vidrio en Las Vegas' : 'Glass Services Across Las Vegas Valley'}
        </p>
        <div className="flex flex-wrap gap-2 justify-center">
          {keywords.map((kw) => (
            <Link
              key={kw.label}
              to={kw.path}
              className="text-xs text-gray-600 bg-white border border-gray-200 px-4 py-2 rounded-full hover:border-black hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              {kw.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeywordsBar;
